import { KnmSubjectTypesEnum } from '../../../KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';

export function mapSubjectTypeCodeToName(code: string | undefined): string | undefined {
  switch (code) {
    case 'IP':
      return KnmSubjectTypesEnum.IP;
    case 'FIZ':
      return KnmSubjectTypesEnum.FIZ;
    case 'FL':
      return KnmSubjectTypesEnum.FIZ;
    case 'UL':
      return KnmSubjectTypesEnum.UR;
    case 'IFIZ':
      return KnmSubjectTypesEnum.IFIZ;
    case 'IFL':
      return KnmSubjectTypesEnum.IFIZ;
    case 'IUL':
      return KnmSubjectTypesEnum.IUR;
    case 'FIUL':
      return KnmSubjectTypesEnum.FIUR;
    default:
      return undefined;
  }
}
